import { atom } from "../app-jotai";

export const accountDialogOpenAtom = atom(false);
